import React from "react";

import { BatchRemoveAnimationContextProvider } from "./useBatchRemoveAnimation";

// component
export const PhotoModAnimationProviders = ({ children }) => {
    return (
        <BatchRemoveAnimationContextProvider>
            {children}
        </BatchRemoveAnimationContextProvider>
    );
};

export default PhotoModAnimationProviders;
